module.exports = __webpack_public_path__ + "img/motion_photos_on-24px.87fdb6fa.svg";